import React, { } from "react";
import { PDFViewer } from '@react-pdf/renderer';
import Certificate from "../../../../components/Certificate/IBSUCertificate/IBSUOfficial";
import { useLocation } from "react-router-dom";

const ViewCertificate = () => {
    const location = useLocation();
    const certificate = location.state?.certificate; // Retrieve certificate data

    if (!certificate) {
        return <p>No certificate data available.</p>;
    }
    return (
        <div className={`card-section`}>
            <div style={{ width: "100%", height: "100vh" }}>
                <PDFViewer width="100%" height="100%">
                    <Certificate  data={certificate} />
                </PDFViewer>
            </div>
        </div>
    );
};

export default ViewCertificate;
